import { render, staticRenderFns } from "./academic-program.vue?vue&type=template&id=6c25993b&scoped=true"
import script from "./academic-program.vue?vue&type=script&lang=js"
export * from "./academic-program.vue?vue&type=script&lang=js"
import style0 from "./academic-program.vue?vue&type=style&index=0&id=6c25993b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25993b",
  null
  
)

export default component.exports